export default [
        
            {"category":"Entertainment: Video Games","type":"multiple","difficulty":"easy",
        "question":"Who is the main character of the game Half-Life: Opposing Force?",
        "correct_answer":"Adrian Shephard","incorrect_answers":["Gordon Freeman","Alyx Vance","Barney Calhoun"]},
        {"category":"Entertainment: Video Games","type":"multiple","difficulty":"easy",
        "question":"Which of these is NOT a Humongous Entertainment game franchise?",
        "correct_answer":"Commander Keen","incorrect_answers":["Pajama Sam","Putt-Putt","Freddi Fish"]},
        {"category":"History","type":"multiple","difficulty":"easy",
        "question":"Who was the Prime Minister of Japan when Japan declared war on the US?",
        "correct_answer":"Hideki Tojo","incorrect_answers":["Michinomiya Hirohito","Isoroku Yamamoto","Fumimaro Konoe"]},
        {"category":"Sports","type":"multiple","difficulty":"easy",
        "question":"Which year did Jenson Button won his first ever Formula One World Drivers&#039; Championship?",
        "correct_answer":"2009","incorrect_answers":["2010","2007","2006"]},
        {"category":"Entertainment: Video Games","type":"multiple","difficulty":"easy",
        "question":"Which psychopath(s) in Dead Rising 1 gave you the small chainsaw?",
        "correct_answer":"Adam the Clown","incorrect_answers":["Cliff Hudson","The convicts","Larry the butcher"]}

]
